import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import ChatInput from "./ChatInput";
import ChatBubble from "./ChatBubble";
import { useChat } from "../context/ChatContext";
import LoadingChatBubble from "./LoadingChatBubble";

const ChatWindow = () => {
	const { chats, isLoading } = useChat();
	const isMobile = useMediaQuery("(max-width:600px)");

	return (
		<Box
			sx={{
				height: isMobile ? "calc(100vh - 270px)" : "calc(100vh - 65px)", // adjust for mobile header size if different
				display: "flex",
				flexDirection: "column",
				paddingX: isMobile ? 2 : 5, // reduce padding on mobile for more screen space
			}}
		>
			{/* This box will contain the chat messages */}
			<Box sx={{ flex: 1, overflowY: "auto", paddingBottom: "56px" }}>
				{chats.map((chat, index) => (
					<ChatBubble
						key={index}
						text={chat.text}
						isResponse={chat.isResponse}
						audioUrl={chat.audioUrl}
					/>
				))}
				{isLoading && <LoadingChatBubble />}
			</Box>
			{/* Ensure ChatInput takes full width */}
			<Box sx={{ width: "100%", marginBottom: isMobile ? 1 : 5 }}>
				<ChatInput />
			</Box>
		</Box>
	);
};

export default ChatWindow;
